import type { FunctionComponent } from 'react';

import { useTheme } from '@/modules/utils/custom-hooks/use-theme';

type LabelBadgeProps = {
  text?: string | null;
  className?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  color?: string | null;
  background?: string;
  pill?: boolean;
  onClick?: () => void;
};

export const LabelBadge: FunctionComponent<LabelBadgeProps> = ({
  text,
  size = 'small',
  color,
  background = 'transparent',
  pill = false,
  className,
  onClick = undefined
}) => {
  const sizeVariants = {
    xsmall: 'text-xs min-w-16 h-4 p-0.5',
    small: 'text-xs min-w-16 h-4 p-1',
    medium: 'text-sm min-w-24 p-1.5 h-5',
    large: 'text-lg min-w-28 p-2 h-6'
  };
  const { isDarkTheme } = useTheme();

  if (!text) return null;

  return (
    <div
      style={{ background: isDarkTheme ? '#F5F5F5' : background, color: color ?? '#000000', boxSizing: 'content-box' }}
      className={`dark:!border ${pill ? 'rounded-full' : 'rounded-none'} ${sizeVariants[size]} overflow-hidden font-normal text-center ${className}`}
      onClick={onClick}
    >
      <span className='whitespace-nowrap'>{text}</span>
    </div>
  );
};
